import { useEffect, useState } from "react";
import axios from "axios";

export function useTenantBranding() {
  const [branding, setBranding] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const tenantPublicId = localStorage.getItem("tenant") || "default";

    if (!tenantPublicId) return;

    const fetchBranding = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_EUREKA_PACS_URL}/api/tenant-branding/${tenantPublicId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        // 🔑 Parse les lignes si c'est une string
        const data = res.data;
        let leftLines = [];
        let rightLines = [];

        try {
          leftLines = data.leftLines ? JSON.parse(data.leftLines) : [];
        } catch {
          leftLines = [];
        }

        try {
          rightLines = data.rightLines ? JSON.parse(data.rightLines) : [];
        } catch {
          rightLines = [];
        }

        setBranding({ ...data, leftLines, rightLines });
      } catch (e) {
        console.error("Branding introuvable :", e);
        // fallback par défaut
        setBranding({
          primaryColor: "#111",
          secondaryColor: "#666",
          logoUrl: "/clinique.png",
          leftLines: ["ÉTABLISSEMENT"],
          rightLines: ["Pays", "Devise"],
          serviceTitle: "SERVICE DE RADIOLOGIE ET IMAGERIE MÉDICALE",
          printCss: "",
        });
      }
    };

    fetchBranding();
  }, []);

  // appliquer couleurs et CSS
  useEffect(() => {
    if (!branding) return;

    const root = document.documentElement;
    root.style.setProperty("--brand-primary", branding.primaryColor || "#111");
    root.style.setProperty("--brand-secondary", branding.secondaryColor || "#666");

    let style = document.getElementById("brand-print-css");
    if (!style) {
      style = document.createElement("style");
      style.id = "brand-print-css";
      document.head.appendChild(style);
    }
    style.innerHTML = branding.printCss || "";
  }, [branding]);

  return branding;
}
